export default __webpack_public_path__ + "static/media/development.a9bdd94e.jpg";